const trustedBy = (element, callback) => {
    const maxWaitTime = 10000;
    const interval = 50;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

trustedBy("#rebuy-cart", () => {
    const cartObserveTrustedBy = new MutationObserver(() => {

        const trustBy = document.createElement("div");
        trustBy.className = "cart-trust-by";

        const trustByIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M11.8188 2.22355C10.2719 2.15075 8.7936 1.56978 7.61066 0.571634C7.25649 0.276252 6.74412 0.276252 6.38993 0.571634C5.20699 1.56978 3.72867 2.15075 2.18316 2.22355C1.68619 2.25855 1.2998 2.67152 1.2998 3.1699V5.1004C1.2998 10.4201 5.33299 12.9106 6.57332 13.5462C6.84351 13.6847 7.16269 13.6847 7.43288 13.5462C8.66761 12.9106 12.7008 10.4201 12.7008 5.1004V3.1699C12.7008 2.67152 12.3158 2.25855 11.8188 2.22355ZM10.1627 5.93336L6.36333 9.25818C6.17435 9.42197 5.89156 9.41217 5.71377 9.23578L4.28864 7.81065C4.10946 7.62446 4.11225 7.32768 4.29564 7.14569C4.47764 6.9623 4.77442 6.9595 4.96061 7.13869L6.07075 8.25023L9.53836 5.2166C9.73576 5.0458 10.0339 5.0668 10.2061 5.26419C10.3783 5.46018 10.3587 5.75977 10.1627 5.93336Z" fill="#44BE70"/>
</svg>`

        trustBy.innerHTML = `
           <div class="trust-by__content">
                ${trustByIcon}
                <p class="trust-by__text">${window.cartStrings.trustedBy}</p>
           </div>
        `;

        const cartTarget = document.querySelector(".rebuy-cart__flyout-subtotal");
        if (cartTarget && !document.querySelector(".cart-trust-by")) {
            cartTarget.before(trustBy);
        }
    })

    cartObserveTrustedBy.observe(document.querySelector("#rebuy-cart"), {
        attributes: true,
        attributeFilter: ["class"]
    });
});